module.exports = __webpack_public_path__ + "img/section4_img2.37f3e590.svg";